module.exports = __webpack_public_path__ + "static/lugano_narrow-f3f5057d8eeff0d8a2eebbc9d4573256.jpg";